import { supabase } from '../lib/supabase';

export const categoryService = {
  async getAll() {
    try {
      const { data, error } = await supabase?.from('categories')?.select('*')?.order('name');

      if (error) {
        throw error;
      }

      const result = data?.map(row => ({
        id: row?.id,
        name: row?.name,
        slug: row?.slug,
        description: row?.description
      })) || [];

      return result;
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  },

  async getById(id) {
    const { data, error } = await supabase?.from('categories')?.select('*')?.eq('id', id)?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      name: data?.name,
      slug: data?.slug,
      description: data?.description
    };
  },

  async getBySlug(slug) {
    const { data, error } = await supabase?.from('categories')?.select('*')?.eq('slug', slug)?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      name: data?.name,
      slug: data?.slug,
      description: data?.description
    };
  },

  async getAllWithCounts() {
    const { data, error } = await supabase
      ?.from('categories')
      ?.select(`
        id,
        name,
        slug,
        description,
        products:products(count)
      `)
      ?.order('name');
    
    if (error) throw error;
    
    return data?.map(row => ({
      id: row?.id,
      name: row?.name,
      slug: row?.slug,
      description: row?.description,
      productCount: row?.products?.[0]?.count || 0
    }));
  },

  async create(category) {
    const { data, error } = await supabase?.from('categories')?.insert({
        name: category?.name,
        slug: category?.slug || null,
        description: category?.description || null
      })?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      name: data?.name,
      slug: data?.slug,
      description: data?.description
    };
  },

  async update(id, category) {
    const { data, error } = await supabase?.from('categories')?.update({
        name: category?.name,
        slug: category?.slug || null,
        description: category?.description || null
      })?.eq('id', id)?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      name: data?.name,
      slug: data?.slug,
      description: data?.description
    };
  },

  async delete(id) {
    const { error } = await supabase?.from('categories')?.delete()?.eq('id', id);
    
    if (error) throw error;
  }
};